export const defaultWaitSettings = () => ({
    waitInterval: {
        value: '',
        required: true
    }
})
